import createReactComponent from '../createReactComponent';
var ScanFace = createReactComponent('ScanFace', [['path', {
  d: 'M3 7V5a2 2 0 0 1 2-2h2',
  key: 'aa7l1z'
}], ['path', {
  d: 'M17 3h2a2 2 0 0 1 2 2v2',
  key: '4qcy5o'
}], ['path', {
  d: 'M21 17v2a2 2 0 0 1-2 2h-2',
  key: '6vwrx8'
}], ['path', {
  d: 'M7 21H5a2 2 0 0 1-2-2v-2',
  key: 'ioqczr'
}], ['path', {
  d: 'M8 14s1.5 2 4 2 4-2 4-2',
  key: '1y1vjs'
}], ['path', {
  d: 'M9 9h.01',
  key: '1q5me6'
}], ['path', {
  d: 'M15 9h.01',
  key: 'x1ddxp'
}]]);
export default ScanFace;